import { render, staticRenderFns } from "./CompareSelect.vue?vue&type=template&id=64e4f468&scoped=true&"
import script from "./CompareSelect.vue?vue&type=script&lang=js&"
export * from "./CompareSelect.vue?vue&type=script&lang=js&"
import style0 from "./CompareSelect.vue?vue&type=style&index=0&id=64e4f468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4f468",
  null
  
)

export default component.exports